module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Backup erstellen")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Alle vorhandenen Tabellen werden als csv-Dateien exportiert.\n            "), _c('br'), _vm._v("Derzeit werden folgende Tabellen exportiert:\n            "), _c('br'), _vm._v("- Kontakte\n            "), _c('br'), _vm._v("- getränke\n            "), _c('br'), _vm._v("- Rechnungen\n            "), _c('br'), _vm._v("- Getränkelieferungen\n            "), _c('br'), _vm._v("- Getränkezählungen\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.backupData()
      }
    }
  }, [_vm._v("Backup erstellen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Adress-Export")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Aus der Kontaktliste werden verschiedenen Kontaktgruppen als einzelne csv-Dateien exportiert.\n            "), _c('br'), _vm._v("- BbrBbr Deutschland\n            "), _c('br'), _vm._v("- BbrBbr Ausland\n            "), _c('br'), _vm._v("- AHAH \n            "), _c('br'), _vm._v("- Aktive\n            "), _c('br'), _vm._v("- HBV-Mitglieder\n            "), _c('br'), _vm._v("- Witwen\n            "), _c('br'), _vm._v("- Freundinnen und Damen\n            "), _c('br'), _vm._v("- Spefüxe und Gäste\n            "), _c('br'), _vm._v("- CV-Verbindungen\n          ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        return _vm.adressExportData()
      }
    }
  }, [_vm._v("Exportieren")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Import")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60566124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/ImExport.vue
// module id = 784
// module chunks = 15